

export function HomeImages() {

    return(
        <div className="home__images relative">
            <img src="/images/app-home.png" alt="app home image"/>
            <img src="/images/app-spot.png" alt="app spot image"/>
        </div>
    );
};